import { render, staticRenderFns } from "./ProductComparisonTableValue.vue?vue&type=template&id=6b9fad3c&"
import script from "./ProductComparisonTableValue.vue?vue&type=script&lang=js&"
export * from "./ProductComparisonTableValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports